import Vue from 'vue'
import VueI18n from 'vue-i18n'

//import ar from 'vuetify/lib/locale/ar'
import en from 'vuetify/lib/locale/en'
//import config from '../config'

Vue.use(VueI18n)

const messages = {
  en: {
    ...require('@/locales/en.json'),
    $vuetify: en,
  },
  es: {
    ...require('@/locales/es.json'),
    $vuetify: en,
  },
}

export default new VueI18n({
  locale: config.VUE_APP_I18N_LOCALE,
  fallbackLocale: config.VUE_APP_I18N_FALLBACK_LOCALE,
  messages,
})
